export { isNativePlatform, getPlatform, hasNativePlugin } from './platform';
export { SecureStorageService } from './secure-storage.service';
export { BiometricService } from './biometric.service';
export { DeepLinkService } from './deep-link.service';
